export enum ButtonStyle {
  DEFAULT = 'btn-primary',
  PRIMARY = 'btn-primary',
  SECONDARY = 'btn-secondary',
  NOBACKGROUND = 'btn-no-background',
  LISTACTION = 'btn-list-action',
  ROWACTION = 'btn-row-action',
  ALERT = 'btn-alert-action',
}

export enum ButtonSize {
  LARGE = 'large',
  EXTRA_SMALL = 'extra-small',
  SMALL = 'small',
}
